<template>
  <div :class="{'single-line':singleLine}" :style="(config.newline && (mappedData !== '')) ? 'margin-top: 8px' : ''"
       class="textfield">
    <template v-if="!isUrlField">
      <strong v-if="config.style === 'strong'"> {{ mappedData }} </strong>
      <i v-else-if="config.style === 'italics'"> {{ mappedData }} </i>
      <template
          v-else
      >
        {{ mappedData }}
      </template>
    </template>
      <template v-else>
        <a :href="mappedData" target="_blank">{{config.label}}</a>
      </template>
  </div>
</template>

<script>
export default {
  name: 'tablefield-text',
  props: ['data', 'config', 'singleLine'],
  computed: {
    isUrlField() {
      return this._.get(this, 'config.path', '').includes('enriched.attachments.link')
    },
    // break long underlying names
    mappedData() {
      if (Array.isArray(this.data)) {
        return this.data.join(' / ')
      }

      let abbreviationMap = {
        'LVMH Moet Hennessy Louis Vuitton SE': 'LVMH',
        'Fresenius SE & Co. KGaA': ' Fresenius SE',
        'Münchener Rückversicherungs-Gesellschaft AG in München': 'Münchener Rück',
        'Fresenius Medical Care AG & Co. KGaA': 'Fresenius Medical Care AG',
        'ROCHE HOLDING AG Inhaber-Genussschein': 'ROCHE HOLDING AG',
        'Vontobel Financial Products GmbH': 'Vontobel',
        'Anheuser-Busch InBev N.V./S.A.': 'Anheuser-Busch',
        'Porsche Automobil Holding SE Vz.': 'Porsche',
        'AIR LIQUIDE-SA ET.EXPL.P.G.CL.': 'AIR LIQUIDE',
        'Alibaba Group Holding Ltd. (ADRs)': 'Alibaba Group',
        'SMA Solar Technology AG': 'SMA Solar',
        'Heidelberger Druckmaschinen AG': 'Heidelberger Druck',
        'Steinhoff International Holdings N.V.': 'Steinhoff International',
      }
      if ((this._.get(this, 'config.path', '').includes('derived.underlying.name')) && this._.get(abbreviationMap, this.data)) {
        return this._.get(abbreviationMap, this.data, this.data)
      } else {
        return this._.isNil(this.data) ? '—' : this.data
      }
    },
  },
}
</script>


<style lang="scss">
.single-line {
  display: inline-block;
  padding-right: 7px;
  padding-left: 7px;
  border-left: 1px solid #696969;

  &:first-child {
    padding-left: 0;
    border-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// FieldText.vue?ceb72532